module.exports = __webpack_public_path__ + "img/Z86Q_10.87329b4a.jpg";